import {dialogContentClasses} from '@mui/material/DialogContent'
import {dividerClasses} from '@mui/material/Divider'
import {mobileStepperClasses} from '@mui/material/MobileStepper'
import {createTheme, responsiveFontSizes} from '@mui/material/styles'

import {SECONDARY_MAIN} from './tokens'

// Keep PURE: a `styled` reading this at module scope stays a static object, not a callback emotion
// re-serializes per instance per render.
export const appTheme = responsiveFontSizes(createTheme({
  palette: {
    secondary: {
      main: SECONDARY_MAIN,
    },
  },
  components: {
    MuiSelect: {
      styleOverrides: {
        select: {
          minHeight: '1.4375em',
          maxHeight: '1.4375em',
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          '&:focus-visible': {
            outline: 'none',
          },
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          [`+ form > .${dialogContentClasses.root}`]: {
            paddingTop: 0,
          },
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        message: {
          flex: 1,
        },
      },
    },
    MuiStack: {
      styleOverrides: {
        root: {
          [`>.${dividerClasses.vertical}:last-child`]: {
            display: 'none',
          },
          [`>.${dividerClasses.vertical}:first-child`]: {
            display: 'none',
          },
        },
      },
    },
    MuiMobileStepper: {
      styleOverrides: {
        root: {
          gap: 8,
          [`>.${mobileStepperClasses.progress}`]: {
            flex: 1,
          },
        },
      },
    },
  },
}))
